import {
  SecondStpStatus,
  SecondStpStatusLabels,
} from "../../../../enums/secondStpStatus";

/** Placeholder shown when a value is missing. */
export const EMPTY_FIELD_VALUE = "--";

/**
 * Resolves a stored second STP status to its display label.
 *
 * @input rawStatus - `second_stp_status` from the order row or a history entry
 * @return Human-readable label, the raw value when unmapped, or a placeholder
 */
export const getSecondStpStatusLabel = (
  rawStatus: string | null | undefined,
): string => {
  const trimmed = rawStatus?.trim() ?? "";
  if (!trimmed || trimmed === EMPTY_FIELD_VALUE) {
    return EMPTY_FIELD_VALUE;
  }

  return SecondStpStatusLabels[trimmed as SecondStpStatus] ?? trimmed;
};
